export default [
  {
    name: 'Name',
    prop: 'name',
    type: 'text'
  }
]
